import React from 'react';
import { motion } from 'framer-motion';

export default function Terms() {
  return (
    <div className="py-16 md:py-24 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          className="prose prose-blue max-w-none text-gray-600"
        >
          <h1 className="text-3xl font-bold text-gray-900 mb-2">Terms of Service</h1>
          <h2 className="text-xl text-gray-700 mb-1">World Class Ventures LLC Terms of Service</h2>
          <p className="text-sm text-gray-500 mb-8">Effective Date: 08/02/2026</p>

          <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">1. Introduction</h2>
          <p>
            These Terms of Service ("Terms") govern your use of the services provided by World Class Ventures LLC ("we," "our," or "us"). By accessing or using our services, you agree to be bound by these Terms.
          </p>

          <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">2. Services</h2>
          <p>
            We provide mortgage and related services ("Services"). We reserve the right to modify or discontinue the Services at any time without notice.
          </p>

          <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">3. Account Registration</h2>
          <p>
            To use our Services, you may need to create an account. You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account.
          </p>

          <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">4. Acceptable Use</h2>
          <p>You agree to use our Services in compliance with all applicable laws and regulations. You must not:</p>
          <ul className="list-disc pl-6 mb-4">
            <li>Use the Services for any unlawful purpose.</li>
            <li>Interfere with or disrupt the Services or servers/networks connected to the Services.</li>
          </ul>

          <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">5. Fees and Payment</h2>
          <p>
            You agree to pay all applicable fees for the Services as outlined in your service agreement. Fees are non-refundable except as required by law.
          </p>

          <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">6. Intellectual Property</h2>
          <p>
            We own all rights, title, and interest in and to the Services, including all intellectual property rights. You are granted a limited, non-exclusive, non-transferable, and revocable license to use the Services for your internal business purposes.
          </p>

          <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">7. Confidentiality</h2>
          <p>
            You agree to maintain the confidentiality of any non-public information disclosed to you by us, including business, technical, and financial information.
          </p>

          <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">8. Privacy</h2>
          <p>
            Your use of the Services is also governed by our Privacy Policy, which is incorporated by reference into these Terms.
          </p>

          <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">9. Limitation of Liability</h2>
          <p>
            To the maximum extent permitted by law, World Class Ventures LLC will not be liable for any indirect, incidental, special, consequential, or punitive damages, or any loss of profits or revenues, whether incurred directly or indirectly, or any loss of data, use, goodwill, or other intangible losses, resulting from:
          </p>
          <ul className="list-disc pl-6 mb-4">
            <li>Your use or inability to use the Services.</li>
            <li>Any unauthorized access to or use of our servers and/or any personal information stored therein.</li>
            <li>Any interruption or cessation of transmission to or from the Services.</li>
          </ul>

          <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">10. Indemnification</h2>
          <p>
            You agree to indemnify, defend, and hold harmless World Class Ventures LLC, its affiliates, officers, directors, employees, and agents from and against any and all claims, liabilities, damages, losses, and expenses, including reasonable attorney's fees, arising out of or in any way connected with your access to or use of the Services or your violation of these Terms.
          </p>

          <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">11. Termination</h2>
          <p>
            We may terminate or suspend your account and access to the Services at our sole discretion, without prior notice or liability, for any reason whatsoever, including without limitation if you breach the Terms. Upon termination, your right to use the Services will immediately cease.
          </p>

          <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">12. Governing Law</h2>
          <p>
            These Terms shall be governed and construed in accordance with the laws of the state of Alabama, without regard to its conflict of law provisions.
          </p>

          <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">13. Links to Other Websites</h2>
          <p>
            Our Service may contain links to third-party web sites or services that are not owned or controlled by World Class Ventures LLC.
          </p>
          <p>
            World Class Ventures LLC has no control over, and assumes no responsibility for, the content, privacy policies, or practices of any third party web sites or services. You further acknowledge and agree that World Class Ventures LLC shall not be responsible or liable, directly or indirectly, for any damage or loss caused or alleged to be caused by or in connection with the use of or reliance on any such content, goods or services available on or through any such web sites or services.
          </p>
          <p>
            We strongly advise You to read the terms and conditions and privacy policies of any third-party web sites or services that You visit.
          </p>

          <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">14. Dispute Resolution</h2>
          <p>
            Any disputes arising out of or in connection with these Terms or the Services shall be resolved through binding arbitration in Mobile, Alabama, in accordance with the rules of the American Arbitration Association.
          </p>

          <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">15. Changes to the Terms</h2>
          <p>
            We reserve the right, at our sole discretion, to modify or replace these Terms at any time. If a revision is material, we will provide at least 30 days' notice prior to any new terms taking effect. What constitutes a material change will be determined at our sole discretion.
          </p>

          <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">16. Contact Us</h2>
          <p>If you have any questions about these Terms, please contact us at:</p>
          <ul className="list-none mb-8">
            <li><strong>Email:</strong> andrewkhong30@gmail.com</li>
            <li><strong>Phone:</strong> +1 (251) 235-2120</li>
            <li><strong>Address:</strong> 4641 Hermitage Rd, Mobile AL 36619</li>
          </ul>

          <p className="font-medium text-gray-900 mt-8">
            By using our Services, you agree to be bound by these Terms.
          </p>
        </motion.div>
      </div>
    </div>
  );
}